import React from 'react';
import I18n from 'i18n-js';
import { RCGrid, RCImage } from '@reverbdotcom/cadence/components';
import { OverflowingRow } from '@reverbdotcom/commons';
import { BrandConfig, brandSampling } from './brand_data';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';

interface BrandProps {
  brand: BrandConfig;
  position: number;
}

function BrandCard(props: BrandProps) {
  return (
    <CoreLink
      to={props.brand.url}
      key={props.brand.slug}
      position={props.position}
      trackName="BestSellingBrandsRow"
      target="_blank"
      className="bg-color-gray-100 bd-radius-xl padding-4 tablet-padding-2 best-selling-brand-card"
      clickEvent={{
        componentName: 'BestSellingBrandsRow',
        eventName: MParticleEventName.ClickedBrand,
        brand: props.brand.slug,
        position: props.position,
      }}
    >
      <RCImage src={props.brand.image} imageBox="auto" />
    </CoreLink>
  );
}

export default function BestSellingBrands() {
  return (
    <OverflowingRow title={I18n.t('discovery.homepage.bestSellingBrands')}>
      <RCGrid singleRowOn="all">
        { brandSampling(6).map((brand, index) => {
          return (
            <RCGrid.Item colSpan={{ desktop: 2, tablet: 2, mobile: 5 }} key={brand.slug}>
              <BrandCard brand={brand} position={index} />
            </RCGrid.Item>
          );
        })}
      </RCGrid>
    </OverflowingRow>
  );
}
